// The student portal's version for the welcome intro («بوابة مشكاة»),
// the platform's version (2.3.0 at the portal's first activation). Bump it
// TOGETHER with a new entry at the top of RELEASES in introContent.js:
// every pupil/parent account then sees «ما الجديد» once. A deploy
// without release notes for them leaves it alone.
export const INTRO_VERSION = '2.3.0';

/** "2.1.0" vs "2.0.3" → 1 / 0 / -1, part by part as numbers. */
export function compareVersions(a, b) {
  const pa = String(a || '0').split('.').map(Number);
  const pb = String(b || '0').split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  return 0;
}
